const setCustomerSlotDetails = (details) => {
  sessionStorage.setItem("CustomerSlotDetails", JSON.stringify(details));
};

const getCustomerSlotDetails = () => {
  return JSON.parse(sessionStorage.getItem("CustomerSlotDetails"));
};

export {setCustomerSlotDetails, getCustomerSlotDetails};
